module.exports = "<div class=\"loans-detail-new-credit-capacity\" ng-class=\"{ 'mobile': $ctrl.isMobileApp }\">\n  <div ng-repeat=\"newCreditCapacity in $ctrl.loan.detail.newCreditCapacity\">\n    <p>\n      {{ newCreditCapacity.text | translate }}\n      <a ng-click=\"$ctrl.redirectFunctions[newCreditCapacity.link]()\" ng-if=\"newCreditCapacity.link !== undefined\">\n        <b>{{ newCreditCapacity.textLink | translate }}</b>\n      </a>\n    </p>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/loans.module/features/loansDetail/loansDetailNewCreditCapacity/loansDetailNewCreditCapacity.html
// module id = 1884
// module chunks = 0